export default __webpack_public_path__ + "static/media/team-img.6d8d440b.jpg";